import Web3 from "web3"

export function sleep(interval) {
  return new Promise((resolve) => {
    setTimeout(resolve, interval);
  });
}

export function debounce(fn, delay) {
  var delay = delay || 200;
  var timer;
  return function () {
    var th = this;
    var args = arguments;
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(function () {
      timer = null;
      fn.apply(th, args);
    }, delay);
  };
}

export function throttle(fn, interval) {
  var last;
  var timer;
  var interval = interval || 200;
  return function () {
    var th = this;
    var args = arguments;
    var now = +new Date();
    if (last && now - last < interval) {
      clearTimeout(timer);
      timer = setTimeout(function () {
        last = now;
        fn.apply(th, args);
      }, interval);
    } else {
      last = now;
      fn.apply(th, args);
    }
  };
}

export const formatWithCommas = (number) => {
  var parts = number.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};


export const fnOpenUrl = (url) => {
  const link = document.createElement('a');
  link.href = url;
  link.target = "_blank";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function confirmLater (promise) {
  return new Promise((resolve, reject) => {
    promise.on('transactionHash', resolve);
    promise.on('error', reject);
    function onConfirm (confNumber, receipt) {
      promise.off('confirmation', onConfirm);
    }
    promise.on('confirmation', onConfirm);
  });
}

export function isApp () {
  // var isIosApp = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(
  //   navigator.userAgent
  // );
  // var isAndroidApp = window.android ? 1 : 0;
  // return isIosApp || isAndroidApp || Web3.givenProvider;
  return (!!Web3.givenProvider || !!window.safepal_wallet_app) && isMobile()
}

export function isMobile () {
  const ua = navigator.userAgent.toLowerCase();
  const testUa = regexp => regexp.test(ua);

  return testUa(/android|adr/g) || testUa(/ios|iphone|ipad|ipod/g) || testUa(/mobile/g) || window.android || testUa(/miui/g)
}
